<script setup>
import KraftchatAIRulesSwitchItem from './KraftchatAIRulesSwitchItem.vue';

import { handoffTriggerOptions } from '../../helpers/kraftchatAIRulesConfig';

const props = defineProps({
  policy: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:policy']);

const updateTrigger = (key, enabled) => {
  const currentTriggers = props.policy.handoff_triggers || [];

  const handoffTriggers = enabled
    ? [...new Set([...currentTriggers, key])]
    : currentTriggers.filter(trigger => trigger !== key);

  emit('update:policy', {
    ...props.policy,
    handoff_triggers: handoffTriggers,
  });
};
</script>

<template>
  <div class="grid gap-3 md:grid-cols-2">
    <KraftchatAIRulesSwitchItem
      v-for="trigger in handoffTriggerOptions"
      :key="trigger.key"
      :label="trigger.title"
      :description="trigger.description"
      :model-value="policy.handoff_triggers?.includes(trigger.key)"
      @update:model-value="updateTrigger(trigger.key, $event)"
    />
  </div>
</template>
